<!-- main component container -->
<div id="welcome-page-container">
  <div class="row">
    <div class="agent-portal-content-spacing  portal-mobile-view">
      <primary-link-component (click)=" goToDemoWelcome() " onkeypress="goToDemoWelcome()"></primary-link-component>
      <h1 class="agent-portal-title hide-on-tablet agent-portal-hide-on-mobile">Take back your time with the John Hancock eApp</h1>
      <h2 style="display: none;"></h2><!--this is for html sonarqube scans-->
      <h3 class="agent-portal-title  mobile-content mobile-center-text">Take back your time with the John Hancock eApp</h3>
    </div>
  </div>

  <div class="agent-portal-content-spacing btn-wrapper" style="display: flex;">
    <button *ngIf="showDebugButton" class="primary-cta-btn jh-font-family"> Simulate decision page </button>
  </div>

  <div class="wp-main">
    <div class="agent-portal-content-spacing">
      <h5>
        Save up to 20 days from submission to policy issue on your next application by taking
        advantage of the John Hancock eApp! Before getting started, please note the following
        submission parameters:
      </h5>

      <h5>
        <ul class=" welcome-page-ul  jh-font-family">
          <li class=" welcome-page-list-item jh-font-family ">
            All single-life, fully underwritten term and permanent products
          </li>
          <li class=" welcome-page-list-item jh-font-family"> Insureds ages 18-79, applying for any face amount </li>
          <li class=" welcome-page-list-item jh-font-family"> Owners ages 20 and older, applying for any face amount </li>
          <li class=" welcome-page-list-item jh-font-family"> U.S. residents </li>
          <li class=" welcome-page-list-item jh-font-family"> All states except New York </li>
        </ul>
      </h5>
    </div>

    <div class="wp-main-right agent-portal-content-spacing">
      <h4 class="jh-font-family"> Key Advantages: </h4>

      <div style="width: 100%; display: flex; flex-direction: column; justify-content: space-between">
        <div class="welcome-page-text-wrapper">
          <i class="fas fa-check confirmation welcome-check"></i>
          <h5 class="wp-text-near-icon">
            <b>
              All in one submission
            </b> <br>
            product-specific rules and all required forms automatically
            built into the application, ensuring in-good-order submissions
          </h5>
        </div>

        <div class="welcome-page-text-wrapper">
          <i class="fas fa-check confirmation welcome-check"></i>
          <h5 class="wp-text-near-icon">
            <b>
              Option to electronically share key sections with clients
            </b> <br>
            so they can complete on their own, at their convenience
          </h5>
        </div>

        <div class="welcome-page-text-wrapper">
          <i class="fas fa-check confirmation welcome-check"></i>
          <h5 class="wp-text-near-icon">
            <b>
              Instant John Hancock ExpressTrack&#174;
            </b> <br>
            for eligible submissions up to and including age 60, and face amounts up to and including $3M
          </h5>
        </div>
      </div>

    </div>
  </div>

  <div class="two-btn-wrapper agent-portal-content-spacing">
    <button class="primary-cta-btn jh-font-family" (click)=" startNewApplication() ">
      Start a new case
    </button>
    <button class="secondary-cta-btn jh-font-family" (click)=" goToMiniPortal() ">
      Resume an existing case
    </button>
  </div>

  <div class="row" *ngIf=" processing ">
    <!-- spinner -->
    <div class="spinner-wrapper text-center mini-portal-agent-app-spinner" [ngClass]="{'show': processing || startNewApp}">
      <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
    </div><!-- /spinner -->
  </div>
  <!-- end row spinner -->

</div>
